export default {
    name: "infos-personnels-tab-content",
    components: {},
    props: {
        patient: Object,
        info_personne_a_prevenir: Object,
        info_assure_principal: { type: Object, default: () => ({}) },
        assurance_loading: Boolean,
        assurance_erreur: Boolean
    },
    computed: {
        can_see_assure() {
            return !this.assurance_loading && !this.assurance_erreur && Number(this.info_assure_principal.est_assure) === 1
        },
    },
    methods: {
        convertDateToDdMmY(date) {
            let d = new Date(date);

            return d.toLocaleDateString();
        },
    },
};
